import { gql } from "@apollo/client";

const EVENT_LOG_QUERY = gql`
  query events(
    $severity: String
    $severities: [String]
    $search: String
    $report_datetime_after: Date
    $report_datetime_before: Date
    $created_after: Date
    $created_before: Date
    $withComments: Boolean
    $projectNames: [String]
    $downloadNames: [String]
    $uploadNames: [String]
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    events(
      severity: $severity
      severities: $severities
      search: $search
      report_datetime_after: $report_datetime_after
      report_datetime_before: $report_datetime_before
      created_after: $created_after
      created_before: $created_before
      withComments: $withComments
      projectNames: $projectNames
      downloadNames: $downloadNames
      uploadNames: $uploadNames
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          report_datetime
          created
          severity
          message
          project_name
          download {
            id
          }
          flow {
            id
          }
          upload {
            id
          }
          will_retry
          comment
          commented_on
          commented_by {
            name
          }
          download_declaration {
            name
          }
          upload_declaration {
            name
          }
          retry_count
          retry_limit
        }
      }
    }
  }
`;

const UPDATE_COMMENT_MUTATION = gql`
  mutation update_comment($id: String!, $comment: String) {
    save_event(id: $id, event: { comment: $comment }) {
      ok
      event {
        comment
      }
    }
  }
`;

export { EVENT_LOG_QUERY, UPDATE_COMMENT_MUTATION };
